import { dataLayerPush } from '@utils/tracking';

export const onRouteChangeComplete = (url: string, { shallow }: { shallow: boolean }) => {
  window.gtag?.('event', 'page_view', {
    page_title: document.title,
    page_location: url,
  });

  dataLayerPush({
    event: 'pageView',
    data: {
      url,
    },
  });

  if (!shallow) window.scrollTo(0, 0);
};
